'use strict';

export default angular
  .module('maestro.services.data.messaging', [
    'maestro.services.webcore'
  ])
  .service('MessagingService', MessagingService)
  .name;

function MessagingService(webcore, $q) {

  /**
   * Returns all notification subscriptions for specific user.
   * @param {number} [userId] User ID for bots and administrators.
   * @returns {Promise}
   */
  this.getNotificationSubscriptions = (userId) => {
    return $q.when(
      webcore.services.messaging.getNotificationSubscriptions(userId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Update specific notification subscription
   * @param {number} type Type of notification to update.
   * @param params Requested parameters.
   * @param {number} [params.userId] User ID for bots and administrators.
   * @param {number} [params.locationId] Location ID.
   * @param {boolean} [params.email] Enable/disable email notificaitons.
   * @param {boolean} [params.push] Enable/disable pushl notificaitons.
   * @param {boolean} [params.sms] Enable/disable sms notificaitons.
   * @param {number} [params.emailPeriod] Minimum number of seconds between email notifications.
   * @param {number} [params.pushPeriod] Minimum number of seconds between push notifications.
   * @param {number} [params.smsPeriod] Minimum number of seconds between sms notifications.
   */
  this.setNotificationSubscriptions = (type, params) => {
    if (type < 1 || isNaN(type)) {
      return $q.reject('Notification type is wrong or not specified!');
    }
    return $q.when(
      webcore.services.messaging.setNotificationSubscriptions(type, params)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Returns history of notifications for specific user.
   * @param params Requested parameters.
   * @param {string} params.startDate Start date to select notifications.
   * @param {number} [params.userId] Get notifications for this user.
   * @param {string} [params.endDate] End date to select notifications. Default is the current date.
   * @param {number} [params.locationId] Get notifications related to this location.
   * @returns {Promise}
   */
  this.getNotifications = (params) => {
    let parameters = params || {};
    parameters.sortCollection = parameters.sortCollection || 'notifications';
    parameters.sortBy = parameters.sortBy || 'sendDateMs';
    parameters.sortOrder = parameters.sortOrder || 'desc';
    return $q.when(
      webcore.services.messaging.getNotifications(parameters)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

}
